import {
	Attempt, ElibraryMetadataDataSource, Product
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyLocalDatabase } from "./idb";
import { getConfig, getCookie } from "./academy";

export class AcademyMetadataDataSource extends ElibraryMetadataDataSource {
	setIncomplete(product: Product, attempt: Attempt): Promise<string> {
		return fetch(
			`/practicequestion/incomplete/${product}/${attempt}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			}
		).then(response => response.json() as Promise<{ result: string }>)
			.then(content => content.result);
	}

	getTestUrl(): Promise<string> {
		const reviewUrl = new URL(window.location.href);
		reviewUrl.pathname = reviewUrl.pathname.replace('result', 'test');
		reviewUrl.hash = document.querySelector<HTMLElement>('.item-list .item[data-status="unanswered"]')
			?.dataset?.id;
		return Promise.resolve(reviewUrl.toString());
	}

	async revertToLocalCookie(): Promise<void> {
		const db = await new AcademyLocalDatabase().getDb();
		const config = getConfig();
		const cookie = getCookie();
		const keys = await db.getAllKeys(AcademyLocalDatabase.global);
		if (keys.some(key => key == cookie) || keys.length <= 0) { return; }
		const replacement = keys[0].toString();
		if ('cookieStore' in window) {
			// @ts-ignore
			await window.cookieStore.set({
				name: config.contentCookie,
				value: replacement,
				path: '/'
			});
		} else {
			document.cookie = `${config.contentCookie}=${replacement};path=/`;
		}
		window.location.reload();
		return;
	}
}
